import styled from 'styled-components';

import { Typography } from '@mui/material';

import { colors } from '../../theme';

interface LabelProps {
    disabled: boolean;
    isError: boolean;
}

const Label = (props: any) => {
    const { disabled, label, icon, isRequired, isError } = props;
    return (
        <LabelBox disabled={disabled} isError={isError}>
            {icon && icon}
            <Typography variant="h6" sx={{ whiteSpace: 'noWrap' }}>
                {label}
            </Typography>
            {isRequired && <span>*</span>}
        </LabelBox>
    );
};

export default Label;

const LabelBox = styled.div<LabelProps>`
    && {
        text-transform: capitalize;
        margin-right: 5px;
        padding: 5px 10px;
        white-space: noWrap;
        background-color: ${(props) => (props.isError ? colors.red.light : colors.blue.light)};
        color: ${(props) => (props.isError ? colors.red.main : colors.blue.main)};
        border-radius: 5px;
        display: flex;
        align-items: center;
        max-height: 28px;

        svg {
            height: 17px;
            width: auto;
            margin-right: 2px;
            path {
                fill: ${colors.blue.main};
            }
        }

        span {
            color: ${colors.red.main};
            margin-left: 5px;
        }

        &:hover {
            cursor: default;
        }
        opacity: ${(props) => (props.disabled ? 0.3 : 1)};
    }
`;
